import { omit } from 'lodash';

import Types from '~/generated/AttributeTypes';

export const attributeTypes = omit(Types, 'DATA');

export const attributeData = Types.DATA;

export default {
  attributeTypes,
  attributeData,
};
